export const PRODUCTION_LOADING = 'PRODUCTION_LOADING';
export const PRODUCTION_EXPENSE_CATEGORY_FULFILLED = 'PRODUCTION_EXPENSE_CATEGORY_FULFILLED';
export const PRODUCTION_FEES_FULFILLED = 'PRODUCTION_FEES_FULFILLED';
